import { RootState } from "@/store/store";
import { explainWithAISliceSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAISliceSelector";

export const explainWithAIModeSelector = (state: RootState) =>
  explainWithAISliceSelector(state).mode;
